import _styled from "styled-components";
import { ArrowPathIcon } from '@heroicons/react/24/outline';
import { Badge } from '../badge';
import { Tooltip } from '../tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Inline badge shown on candidate cards (employer-app kanban + shortlist) and on
 * the worker's own applications list when the underlying JobPosition has been
 * edited after the relevant reference date (`added_to_shortlist_at` for the
 * employer-facing kanban, `inserted_at` for the worker's own view).
 *
 * Pure presentation: visibility rules live in the calling component.
 */
export var JobUpdatedBadge = function JobUpdatedBadge(_ref) {
  var label = _ref.label,
      tooltipText = _ref.tooltipText,
      updatedAtLabel = _ref.updatedAtLabel;

  var badgeEl = /*#__PURE__*/_jsx(Badge, {
    variant: "warning",
    children: /*#__PURE__*/_jsxs(InnerWrapper, {
      children: [/*#__PURE__*/_jsx(ArrowPathIcon, {
        className: "h-3.5 w-3.5"
      }), /*#__PURE__*/_jsx("span", {
        children: label
      })]
    })
  });

  if (!tooltipText) return badgeEl;
  return /*#__PURE__*/_jsx(Tooltip // High z so it floats above the worker-app navbar (z-50) on the
  // candidature detail page; otherwise the popup is clipped by the header.
  , {
    className: "max-w-[320px] text-center !z-[9999]",
    content: /*#__PURE__*/_jsxs(TooltipBody, {
      children: [/*#__PURE__*/_jsx("div", {
        children: tooltipText
      }), updatedAtLabel && /*#__PURE__*/_jsx(UpdatedAt, {
        children: updatedAtLabel
      })]
    }),
    children: badgeEl
  });
};
export default JobUpdatedBadge;

var InnerWrapper = /*#__PURE__*/_styled.span.withConfig({
  displayName: "job-updated-badge__InnerWrapper",
  componentId: "sc-lhv9kt-0"
})(["", ""], {
  "display": "inline-flex",
  "alignItems": "center",
  "gap": "0.25rem",
  "lineHeight": "1"
});

var TooltipBody = /*#__PURE__*/_styled.div.withConfig({
  displayName: "job-updated-badge__TooltipBody",
  componentId: "sc-lhv9kt-1"
})(["", ""], {
  "maxWidth": "260px",
  "textAlign": "left",
  "fontSize": "0.75rem",
  "lineHeight": "1rem"
});

var UpdatedAt = /*#__PURE__*/_styled.div.withConfig({
  displayName: "job-updated-badge__UpdatedAt",
  componentId: "sc-lhv9kt-2"
})(["", ""], {
  "marginTop": "0.25rem",
  "fontSize": "0.75rem",
  "lineHeight": "1rem",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))",
  "opacity": "0.8"
});